const actions = {
  SELECT_REPORT_TYPE: 'SELECT_REPORT_TYPE',
  CHOOSE_REPORT_COMPONENT_TYPE: 'CHOOSE_REPORT_COMPONENT_TYPE',

  FETCH_MONITORING_MENU_DATA: 'FETCH_MONITORING_MENU_DATA',
  FETCHING_MONITORING_MENU_DATA: 'FETCHING_MONITORING_MENU_DATA',
  FETCH_MONITORING_MENU_DATA_SUCCESS: 'FETCH_MONITORING_MENU_DATA_SUCCESS',
  FETCH_MONITORING_MENU_DATA_FAILED: 'FETCH_MONITORING_MENU_DATA_FAILED',

  FILTER_REPORT_TRANSACTIONS: 'FILTER_REPORT_TRANSACTIONS',
  FILTERING_REPORT_TRANSACTIONS: 'FILTERING_REPORT_TRANSACTIONS',
  FILTER_REPORT_TRANSACTIONS_SUCCESS: 'FILTER_REPORT_TRANSACTIONS_SUCCESS',
  FILTER_REPORT_TRANSACTIONS_FAILED: 'FILTER_REPORT_TRANSACTIONS_FAILED',
  RESET_FILTER_REPORTS: 'RESET_FILTER_REPORTS',

  DOWNLOAD_REPORT_TRANSACTIONS: 'DOWNLOAD_REPORT_TRANSACTIONS',
  DOWNLOADING_REPORT_TRANSACTIONS: 'DOWNLOADING_REPORT_TRANSACTIONS',
  DOWNLOAD_REPORT_TRANSACTIONS_SUCCESS: 'DOWNLOAD_REPORT_TRANSACTIONS_SUCCESS',
  DOWNLOAD_REPORT_TRANSACTIONS_FAILED: 'DOWNLOAD_REPORT_TRANSACTIONS_FAILED',

  CLEAR_MESSAGE: 'CLEAR_MESSAGE',

  clearMessage: () => ({
    type: actions.CLEAR_MESSAGE
  }),

  selectReportType: payload => ({
    type: actions.SELECT_REPORT_TYPE,
    payload
  }),
  chooseReportType: payload => ({
    type: actions.CHOOSE_REPORT_COMPONENT_TYPE,
    payload
  }),
  fetchAllMonitoringMenu: payload => ({
    type: actions.FETCH_MONITORING_MENU_DATA,
    payload
  }),
  filterReportTransactions: payload => ({
    type: actions.FILTER_REPORT_TRANSACTIONS,
    payload
  }),
  resetFilterRepport: () => ({
    type: actions.RESET_FILTER_REPORTS
  }),
  downloadReportTransactions: payload => ({
    type: actions.DOWNLOAD_REPORT_TRANSACTIONS,
    payload
  })
};
export default actions;
